import { styled } from '@mui/material/styles';
import { Section } from 'components/styledComponents';

export const PlacementsSection = styled(Section)(({ theme }) => ({
  padding: theme.spacing(5, 0, 8, 0)
}));
